/**
 * Bubble — replica main.css:.bubble (líneas 246-285) en 3 variantes.
 *  - staff: white bg, border, max-width 80%, align left, tail bottom-left 6px
 *  - me:    brand-soft bg, brand-ink color, align right, tail bottom-right 6px
 *  - system: dashed border centered, smaller (12px text-soft)
 *
 * Animation slideIn 0.25s ease-out via class .bubble (definida en index.css).
 */
import type { ReactNode } from 'react'

export type BubbleVariant = 'staff' | 'me' | 'system'

interface Props {
  variant: BubbleVariant
  time?: string
  children: ReactNode
  /** Render children sin el wrapper de bubble (usado para cards inline en chat). */
  raw?: boolean
}

export function Bubble({ variant, time, children, raw = false }: Props) {
  if (raw) {
    return <div className={`bubble-row ${variant === 'me' ? 'me' : ''}`}>{children}</div>
  }

  const isMe = variant === 'me'
  const isSystem = variant === 'system'

  if (isSystem) {
    return (
      <div className="bubble-row system">
        <div
          className="text-[12px] mx-auto px-3 py-1.5"
          style={{
            color: 'var(--color-text-soft)',
            border: '1px dashed var(--color-border-strong)',
            borderRadius: 999,
            background: 'var(--color-bg)',
          }}
        >
          {children}
        </div>
      </div>
    )
  }

  return (
    <div className={`bubble-row ${isMe ? 'me' : ''}`}>
      <div
        className={`bubble ${isMe ? 'me' : 'staff'}`}
        style={{
          maxWidth: '80%',
          padding: '10px 14px',
          borderRadius: 'var(--radius-l)',
          background: isMe ? 'var(--color-bubble-me)' : 'var(--color-bubble-staff)',
          color: isMe ? 'var(--color-bubble-me-ink)' : 'var(--color-text)',
          border: isMe
            ? 'none'
            : '1px solid var(--color-bubble-staff-border)',
          [isMe ? 'borderBottomRightRadius' : 'borderBottomLeftRadius']: 6,
          fontSize: 15,
          lineHeight: 1.4,
        }}
      >
        {children}
        {time && (
          <div
            className="text-[12px] tabular-nums mt-1"
            style={{
              color: 'var(--color-text-soft)',
              fontFamily: 'var(--font-mono)',
            }}
          >
            {time}
          </div>
        )}
      </div>
    </div>
  )
}
